import objectFitImages from 'object-fit-images';

// https://github.com/fregante/object-fit-images
objectFitImages();

/**
 * Indicate if the header should have fill color or if should be transparent on page load
 */
function pageHeaderDetection() {
    // find the first section
    const firstSection = document.getElementById('section-number-1');
    // check if it has background color or background image
    const hasBgColor = firstSection.classList.contains('section--bg-color');
    const hasBgImg = firstSection.classList.contains('section--bg-img');
    const hasPageHeader = firstSection.classList.contains('s-page-header');
    const hasPageHeaderSimple = firstSection.classList.contains('s-page-header-simple');

    // keep the site header transparent
    if (hasBgColor || hasBgImg || hasPageHeader || hasPageHeaderSimple) {
        return;
    }

    // make site header white
    /* TODO: replace .js-no-page-header class with something js-header-white or js-header-fill-color */
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('js-no-page-header');
}
pageHeaderDetection();

/**
 * Reduce padding of section with a background color
 * when a section before or after has also a background color
 *
 * TODO: only reduce padding if sections have the same background color
 */
$(window).load(function () {
    // immediately run this function
    (() => {
        /* get all section with background color */
        const bgColorSections = document.querySelectorAll('.section--bg-color');

        /* do something with each found section */
        bgColorSections.forEach(function (section) {
            const sectionBgColor = window.getComputedStyle(section).getPropertyValue('background-color'),
                prevSection = section.previousElementSibling,
                nextSection = section.nextElementSibling;

            let prevSectionBgColor = null,
                nextSectionBgColor = null;

            if (prevSection !== null) {
                prevSectionBgColor = window.getComputedStyle(prevSection).getPropertyValue('background-color');
            }

            if (nextSection !== null) {
                nextSectionBgColor = window.getComputedStyle(nextSection).getPropertyValue('background-color');
            }

            /* if the current section has the same background color as prev section,
            reduce its top padding */
            if (null !== prevSection && sectionBgColor === prevSectionBgColor) {
                /* console.log('a section with bg-color before'); */
                section.classList.add('section--top-p-small');
            }

            /* if the current section has the same background color as next section,
            reduce its bottom padding */
            if (null !== nextSection && sectionBgColor === nextSectionBgColor) {
                /* console.log('a section with bg-color after'); */
                section.classList.add('section--bottom-p-small');
            }
        });
    })();
});

// $(document).on('click', 'a.c-submenu__link[href^="#"]', function (event) {
//     event.preventDefault();

//     $('html, body').animate({
//         scrollTop: $($.attr(this, 'href')).offset().top - 70,
//     }, 500);
// });

// Smooth scroll on anchor link click
// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('a.c-submenu__link[href^="#"]')
    .click(function (event) {
        // On-page links
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            // Figure out element to scroll to
            let target = $(this.hash),
                header = $('.site-header'),
                targetTopMargin = parseInt(target.css('margin-top'), 10) / 2, // half of top margin
                scrollLength = target.offset().top - header.outerHeight() - targetTopMargin;

            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate(
                    {
                        scrollTop: scrollLength,
                    },
                    1000,
                    function () {
                        // Callback after animation
                        // Must change focus!
                        let $target = $(target);
                        $target.focus();
                        if ($target.is(':focus')) {
                            // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    }
                )
            }
        }
    });


$(document).on('click', '#logout', function(e) {
    e.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: {
            'action': 'logout',
        },
        success: function() {
            // When the response comes back
            window.location.href = '/';
        },
    });
});

// Responsive Iframe, keep ratio
var $all_oembed_videos = $('iframe[src*="youtube"], iframe[src*="vimeo"]');
$all_oembed_videos.each(function () {
    $(this).removeAttr('height').removeAttr('width').wrap('<div class="embed-container"></div>');
});


// WEBPACK FOOTER //
// ./scripts/routes/other/generic.js